import React from 'react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import DebouncedInput from '../../debounced_input'
import store from '../../../state/store'

class EditCustomer extends React.Component {

  onDone = () => {
    this.props.onDone()
  }

  onFirstNameChange = (value) => {
    store.emit('enquiry:customers:update', this.props.enquiry_id, this.props.customer.id, {first_name: value})
  }

  onLastNameChange = (value) => {
    store.emit('enquiry:customers:update', this.props.enquiry_id, this.props.customer.id, {last_name: value})
  }

  onEmailAddressChange = (value) => {
    store.emit('enquiry:customers:update', this.props.enquiry_id, this.props.customer.id, {email_address: value})
  }

  onEmailCcChange = (value) => {
    store.emit('enquiry:customers:update', this.props.enquiry_id, this.props.customer.id, {email_cc: value})
  }

  onMobileNumberChange = (value) => {
    store.emit('enquiry:customers:update', this.props.enquiry_id, this.props.customer.id, {mobile_number: value})
  }

  onRelationshipChange = (value) => {
    store.emit('enquiry:enquiry_customers:update', this.props.enquiry_customer.id, {relation_to_learner: value})
  }

  render() {
    return (
      <div className="grid gap-4">
        <div className="grid gap-2">
          <Label>First Name</Label>
          <DebouncedInput value={this.props.customer.first_name} placeholder="First Name" onChange={this.onFirstNameChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Last Name</Label>
          <DebouncedInput value={this.props.customer.last_name} placeholder="Last Name" onChange={this.onLastNameChange}/>
          {(this.props.customer.name !== this.props.enquiry_customer.name) ?
            <span className="text-xs text-muted-foreground">
              Enquired with {this.props.enquiry_customer.name}
            </span>
            : null
          }
        </div>
        <div className="grid gap-2">
          <Label>Email Address</Label>
          <DebouncedInput value={this.props.customer.email_address} placeholder="Email Address" onChange={this.onEmailAddressChange}/>
          {(this.props.customer.email_address !== this.props.enquiry_customer.email_address) ?
            <span className="text-xs text-muted-foreground">
              Enquired with {this.props.enquiry_customer.email_address}
            </span>
            : null
          }
        </div>
        <div className="grid gap-2">
          <Label>Email CC</Label>
          <DebouncedInput value={this.props.customer.email_cc || ''} placeholder="Email CC" onChange={this.onEmailCcChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Mobile Number</Label>
          <DebouncedInput value={this.props.customer.mobile_number} placeholder="Mobile Number" regex={/^\+?(\d)*$/} onChange={this.onMobileNumberChange}/>
          {(this.props.customer.mobile_number !== this.props.enquiry_customer.mobile_number) ?
            <span className="text-xs text-muted-foreground">
              Enquired with {this.props.enquiry_customer.mobile_number}
            </span>
            : null
          }
        </div>
        <div className="grid gap-2">
          <Label>Relation</Label>
          <DebouncedInput value={this.props.enquiry_customer.relation_to_learner || ''} placeholder="Relation To Learner" onChange={this.onRelationshipChange}/>
        </div>
        <div className="flex justify-end gap-2">
          <Button size="sm" onClick={this.onDone}>Done</Button>
        </div>
      </div>
    )
  }
}

export default EditCustomer
